<template>
  <div
    v-if="isRunningInElectron && isLogin && !isLoginPage"
    class="function-menu"
    :class="{ 'login-page': isLoginPage }"
    @click.prevent="checkMenuListState"
  >
    <div v-if="isShowMenuList" class="function-menu-mask" @click.stop.capture="clearMark" />
    <div class="bg" />
    <div v-if="!isMoving && isShowMenuList" class="menu-list">
      <div v-if="!isLoginHone" class="menu-item return" @click.stop="operationFunctionMenu('home')">
        <div class="menu-item-icon" />
        <div>返回主页</div>
      </div>
      <!--      <div v-if="classData?.id" class="menu-item collect" @click.stop="operationFunctionMenu('collect')">-->
      <!--        <div class="menu-item-icon" />-->
      <!--        <div>答卷收集</div>-->
      <!--      </div>-->
      <div v-if="isLoginHone" class="menu-item pop-quiz" @click.stop="operationFunctionMenu('pop-quiz')">
        <div class="menu-item-icon" />
        <div>旧随堂检测</div>
      </div>
      <div
        v-if="isLoginHone"
        class="menu-item teaching-package"
        @click.stop="operationFunctionMenu('teaching-package')"
      >
        <div class="menu-item-icon" />
        <div>授课包</div>
      </div>
      <div class="menu-item bind" @click.stop="operationFunctionMenu('bind')">
        <div class="menu-item-icon" />
        <div>绑定设备</div>
      </div>
      <div v-if="isOffline" class="menu-item return" @click.stop="operationFunctionMenu('login')">
        <div class="menu-item-icon" />
        <div>返回登录</div>
      </div>
      <div class="menu-item reduction" @click.stop="operationFunctionMenu('desktop')">
        <div class="menu-item-icon" />
        <div>回到桌面</div>
      </div>
      <div class="menu-item keyboard" @click.stop="operationFunctionMenu('keyboard')">
        <div class="menu-item-icon" />
        <div>打开键盘</div>
      </div>
      <div
        class="menu-item brush"
        @click="operationFunctionMenu('brush')"
        @mouseover="handleMouseOver"
        @mouseout="handleMouseOut"
      >
        <svg-icon
          :name="brushIconName"
          class="menu-item-icon paint-brush"
          style="width: 20px; height: 20px"
          font-size="18"
        />
        <div>打开画笔</div>
      </div>
      <div ref="timerRef" class="menu-item timer" @click.stop="operationFunctionMenu('timer')">
        <div class="menu-item-icon" />
        <div>{{ globalTimerVisible ? '关闭计时器' : '打开计时器' }}</div>
      </div>
      <div class="menu-item restart-dtq" @click.stop="operationFunctionMenu('restart-dtq')">
        <div class="menu-item-icon" />
        <div>重启接收器</div>
      </div>
      <div class="menu-item toggle" @click.stop="operationFunctionMenu('toggle')">
        <div class="menu-item-icon" />
        <div>切换账号</div>
      </div>
      <div class="menu-item logoff" @click.stop="operationFunctionMenu('program')">
        <div class="menu-item-icon" />
        <div>退出程序</div>
      </div>

      <div v-show="timerOptionListVisible" class="timer-list">
        <div
          v-for="(item, index) in timerOptionList"
          :key="item.value"
          :class="['timer-item', { 'mt-14': index > 0 }]"
          @click.stop="handleClickTimerOption(item)"
        >
          {{ item.label }}
        </div>
        <div class="timer-item mt-14" @click="handleClickCustomTimer">自定义</div>
      </div>
    </div>

    <bind-d-t-q-modal ref="BindDTQModalRef" />

    <paint-brush ref="paintBrushRef" v-move @close="handleClose" />
  </div>
</template>

<script>
import { fetchOffline, isRunningInElectron } from '@/utils/electronUtils'
import { getToken } from '@/utils/auth'
import throttleV2 from '@/utils/throttleV2'
import BindDTQModal from '@/components/common/BindDTQModal.vue'
import PaintBrush from '@/components/paintBrush/paintBrush.vue'
import { mapActions } from 'vuex'

export default {
  name: 'FunctionMenu',
  components: {
    BindDTQModal,
    PaintBrush
  },
  directives: {
    move(el, binging, vnode) {
      const that = vnode.context
      // === 监听触屏滑动事件 -- 指针事件 start ===
      el.onpointerdown = function (e) {
        // 触发canvas画板，禁止移动画笔托盘icon
        if (e.target?.dataset?.name === 'canvas') {
          return
        }

        let timer = setTimeout(() => {
          // 获取浏览器窗口文档显示区域的宽度和高度,不包括滚动条。
          const { clientWidth, clientHeight } = document.documentElement
          const disX = e.clientX - el.offsetLeft
          const disY = e.clientY - el.offsetTop
          // const translate = getTranslateStyle(el)

          throttleV2(
            (el.onpointermove = function (ev) {
              const event = ev || window.event

              // // 移动后的位置 = 当前位置 + （当前触摸的位置 - 上次触摸的位置）
              // const left = translate.left + (event.clientX - e.clientX)
              // const top = translate.top + (event.clientY - e.clientY)
              // el.style.transform = `translate(${left}px, ${top}px)`

              // 鼠标位置减去鼠标相对于当前元素的位置 获取此时此刻元素应该处于的位置
              let left = event.clientX - disX
              let top = event.clientY - disY
              // 获取元素的宽高
              const { offsetWidth, offsetHeight } = el
              // 设置当前元素的位置 不能超出可视区域
              if (left < 0) {
                left = 0
              }

              if (left > clientWidth - offsetWidth) {
                left = clientWidth - offsetWidth
              }
              if (top < 0) {
                top = 0
              }

              if (top > clientHeight - offsetHeight) {
                top = clientHeight - offsetHeight
              }
              el.style.left = left + 'px'
              el.style.top = top + 'px'

              that.$refs.paintBrushRef.isMoving = true
              el.style.cursor = 'move'
            }),
            100
          )
        }, 10)
        // 手势up时不再移动
        el.onpointerup = function (e) {
          clearTimeout(timer)
          timer = null
          el.onpointermove = null
          setTimeout(() => {
            that.$refs.paintBrushRef.isMoving = false
          }, 50)
          el.style.cursor = ''
        }
      }
    }
  },
  data() {
    return {
      isShowMenuList: false,
      isRunningInElectron: false,
      isMoving: false,
      isLogin: false,
      isOffline: fetchOffline(),
      // showBrushVisible: false, // 是否显示画笔
      brushIconName: 'paint-brush',
      openedBrushPop: false, // 是否弹出过气泡
      timerOptionList: [
        { label: '1分钟', value: 1 },
        { label: '3分钟', value: 3 },
        { label: '5分钟', value: 5 },
        { label: '10分钟', value: 10 }
      ],
      globalTimerVisible: false,
      timerOptionListVisible: false,
      isLoginHone: false //是否登陆并且在首页
    }
  },
  computed: {
    showBrushVisible() {
      return this.$store.getters.showBrushVisible
    },
    classData() {
      return this.$store.getters.classData
    },
    isLoginPage() {
      return this.$route.name === 'Login'
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    $route(to) {
      // this.isShowTitle = to?.meta?.isShowTitle
      // 未登录 && 在主页
      this.isLogin = !!getToken()
      this.isLoginHone =
        !!getToken() && this.userInfo?.thirdPartyType === 7 ? to.path === '/home' : to.path === '/home-v2'
    }
  },
  created() {
    this.isRunningInElectron = isRunningInElectron()
    this.isLogin = !!getToken()
  },
  methods: {
    ...mapActions('paperCollect', ['setCurrentClazzId']),
    handleClose() {
      this.$store.dispatch('app/setShowBrushVisible', false)
    },
    clearMark() {
      if (this.isMoving) {
        this.isShowMenuList = false
        return
      }
      this.timerOptionListVisible = false
      this.isShowMenuList = false
    },

    handleMouseOver(e) {
      this.brushIconName = 'paint-brush-active'
    },

    handleMouseOut(e) {
      this.brushIconName = 'paint-brush'
    },
    checkMenuListState() {
      if (this.isMoving) {
        this.isShowMenuList = false
        return
      }

      // 当打开画笔时，禁止点击系统托盘
      if (this.showBrushVisible) {
        this.isShowMenuList = false
        return
      }

      if (this.timerOptionListVisible) {
        this.timerOptionListVisible = false
        this.$refs.timerRef.classList.remove('hover')
        this.isShowMenuList = false
        return
      }

      this.isShowMenuList = !this.isShowMenuList
    },

    // 操作功能菜单
    operationFunctionMenu(item) {
      switch (item) {
        case 'pop-quiz':
          this.$router.push({ name: 'PopQuizList' })
          break
        case 'teaching-package':
          this.goToTeachingPackage()
          break
        case 'home':
          this.returnHome()
          break
        case 'login':
          this.returnLogin()
          break
        case 'desktop':
          this.backDesktop()
          break
        case 'program':
          this.quitApp()
          break
        case 'keyboard':
          this.openKeyboard()
          break
        case 'bind':
          this.openBindModal()
          break
        case 'brush':
          this.openBrush()
          this.brushIconName = 'paint-brush'
          break
        // case 'collect':
        //   this.gotoCollect()
        //   break
        case 'timer':
          if (this.globalTimerVisible) {
            this.$bus.$emit('hideGlobalTimer')
            this.globalTimerVisible = false
            this.isShowMenuList = false
          } else {
            this.$refs.timerRef.classList.add('hover')
            this.timerOptionListVisible = true
          }
          return
        case 'toggle':
          this.logout(true)
          break
        case 'restart-dtq':
          window.electron.ipcRenderer.send('restart-dtq-exe')
          break
      }
      this.checkMenuListState()
    },
    returnHome() {
      this.$confirm({
        title: '是否返回主页?',
        maskClosable: true,
        okText: '确认',
        cancelText: '取消',
        centered: true,
        onOk: () => {
          this.$router.push({ name: this.userInfo?.thirdPartyType === 7 ? 'Home' : 'HomeV2' })
        }
      })
    },
    // 跳转到旧版授课包管理
    goToTeachingPackage() {
      this.$router.push({ name: 'TeachingManagement' })
    },
    returnLogin() {
      const that = this
      this.$confirm({
        title: '是否返回登录?',
        maskClosable: true,
        okText: '确认',
        cancelText: '取消',
        centered: true,
        onOk() {
          that.$router.push({ name: 'Login', query: { quit: '1' } }).then()
        }
      })
    },
    // 退出/返回登录
    async logout(isReturnLogin) {
      await this.$store.dispatch('user/logout')
      // 清除临时缓存的单词作答记录
      sessionStorage.removeItem('wordAnswerStorage')
      sessionStorage.removeItem('pkSelectedWordIds')
      sessionStorage.removeItem('pkSelectedWords')
      sessionStorage.removeItem('pkSelectedStudent')
      if (isReturnLogin) {
        if (this.isRunningInElectron) {
          window.electron.ipcRenderer.send('back-to-login')
        } else {
          this.$router.push({ path: '/login', query: { quit: '1' } }).then()
        }
      }
    },
    // 回到桌面
    backDesktop() {
      if (isRunningInElectron()) {
        window.electron.ipcRenderer.send('window-min')
      }
    },
    // 退出程序
    quitApp() {
      // const that = this
      // this.$confirm({
      //   title: '是否确认退出程序?',
      //   maskClosable: true,
      //   okText: '确认',
      //   cancelText: '返回',
      //   centered: true,
      //   onOk() {
      //     that.logout(false)
      //     window.electron.ipcRenderer.send('window-hide')
      //   }
      // })
      // that.logout(false)
      window.electron.ipcRenderer.send('window-hide')
    },
    openKeyboard() {
      window.electron.ipcRenderer.send('open-osk')
    },
    openBindModal() {
      this.$refs.BindDTQModalRef.openModal()

      // iframe页面修改了a-modal样式，导致绑定设备弹框样式污染，故内聚处理绑定设备弹框
      // this.$emit('openBindModal')
    },

    // 打开画笔面板
    openBrush() {
      this.$refs.paintBrushRef.open(this.openedBrushPop)
      if (!this.openedBrushPop) {
        this.openedBrushPop = true
      }
      // this.showBrushVisible = true
      this.$store.dispatch('app/setShowBrushVisible', true)
      this.isShowMenuList = false
      // this.$emit('openBrush')
    },
    // gotoCollect() {
    //   this.setCurrentClazzId(this.classData?.id)
    //   this.$router.push({ name: 'PaperCollectList' })
    // },
    handleClickTimerOption(item) {
      this.$bus.$emit('showGlobalTimer', item.value)
      this.globalTimerVisible = true
      this.isShowMenuList = false
    },
    handleClickCustomTimer() {
      this.$bus.$emit('showGlobalTimerCustomModal')
      this.isShowMenuList = false
    }
  }
}
</script>

<style scoped lang="scss">
.function-menu {
  position: fixed;
  /* 初始位置由 App.vue v-move 指令在 bind 阶段通过 JS 转换为 left/top，此处仅作降级兜底 */
  right: 60px;
  bottom: 60px;
  z-index: 999;
  width: 56px;
  height: 56px;
  background: #cdeb28;
  box-shadow: 0px 4px 15px 0px rgba(0, 105, 139, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  user-select: none;
  cursor: pointer;

  &.login-page {
    background: #fff;
  }

  .function-menu-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  .bg {
    width: 38px;
    height: 38px;
    background-image: url('@/assets/choose-class-v2/menu.png');
    background-size: 100% 100%;
  }

  .menu-list {
    position: absolute;
    z-index: 9999;
    right: -2px;
    top: 50%;
    transform: translateY(-90%);
    //top: -270%;
    //top: -190px;
    //height: 180px;
    height: auto;
    width: 171px;
    background: #ffffff;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    padding: 14px;
    padding-bottom: 0;

    .menu-item {
      width: 100%;
      height: 44px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 17px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      padding: 10px 14px;
      margin-bottom: 10px;

      &.pop-quiz {
        .menu-item-icon {
          background-image: url('../../assets/bar/paper-collect.png');
        }
      }

      &.return {
        .menu-item-icon {
          background-image: url('../../assets/bar/return.png');
        }
      }

      &.teaching-package {
        .menu-item-icon {
          background-image: url('../../assets/bar/paper-collect.png');
        }
      }

      &.collect {
        .menu-item-icon {
          background-image: url('../../assets/bar/paper-collect.png');
        }
      }

      &.bind {
        .menu-item-icon {
          background-image: url('../../assets/bar/bind-equipment.png');
        }
      }

      &.reduction {
        .menu-item-icon {
          background-image: url('../../assets/bar/reduction.png');
        }
      }

      &.logoff {
        .menu-item-icon {
          background-image: url('../../assets/bar/logoff.png');
        }
      }

      &.keyboard {
        .menu-item-icon {
          background-image: url('../../assets/bar/keyboard.png');
        }
      }

      &.brush {
        .menu-item-icon {
          color: #595959;
          background-image: url('../../icons/svg/paint-brush.svg');
        }
      }

      &.timer {
        &.hover {
          background: #f6f6f6;
          color: #1976ff;
          .menu-item-icon {
            background-image: url('../../assets/bar/timer-active.png');
          }
        }
        .menu-item-icon {
          background-image: url('../../assets/bar/timer.png');
        }
      }

      &.toggle {
        .menu-item-icon {
          background-image: url('../../assets/bar/toggle.png');
        }
      }

      &.restart-dtq {
        .menu-item-icon {
          background-image: url('../../assets/bar/restart-dtq.png');
        }
      }

      &:hover {
        background: #f6f6f6;
        color: #1976ff;

        &.pop-quiz {
          .menu-item-icon {
            background-image: url('../../assets/bar/paper-collect-active.png');
          }
        }

        &.return {
          .menu-item-icon {
            background-image: url('../../assets/bar/return-active.png');
          }
        }

        &.teaching-package {
          .menu-item-icon {
            background-image: url('../../assets/bar/paper-collect-active.png');
          }
        }

        &.collect {
          .menu-item-icon {
            background-image: url('../../assets/bar/paper-collect-active.png');
          }
        }

        &.reduction {
          .menu-item-icon {
            background-image: url('../../assets/bar/reduction-active.png');
          }
        }

        &.logoff {
          .menu-item-icon {
            background-image: url('../../assets/bar/logoff-active.png');
          }
        }

        &.keyboard {
          .menu-item-icon {
            background-image: url('../../assets/bar/keyboard-active.png');
          }
        }

        &.brush {
          .menu-item-icon {
            background-image: url('../../icons/svg/paint-brush-active.svg');
          }
        }

        &.timer {
          .menu-item-icon {
            background-image: url('../../assets/bar/timer-active.png');
          }
        }

        &.toggle {
          .menu-item-icon {
            background-image: url('../../assets/bar/toggle-active.png');
          }
        }

        &.restart-dtq {
          .menu-item-icon {
            background-image: url('../../assets/bar/restart-dtq-active.png');
          }
        }
      }

      &:first-line {
        margin-bottom: 0;
      }

      .menu-item-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background-size: 100% 100%;
      }
    }

    .timer-list {
      position: absolute;
      left: -92px;
      bottom: 44px;
      width: 92px;
      background: linear-gradient(180deg, #e8f1ff 0%, #f1f1f1 100%);
      border-radius: 24px 0 0 24px;
      padding: 14px 20px;
      &::before,
      &::after {
        content: '';
        position: absolute;
        right: 0;
        display: block;
        width: 44px;
        height: 44px;
        background-size: 100% 100%;
      }
      &::before {
        top: -44px;
        background-image: url('@/assets/bar/timer-list-top-side.png');
      }

      &::after {
        bottom: -44px;
        background-image: url('@/assets/bar/timer-list-bottom-side.png');
      }

      .timer-item {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: center;
        cursor: pointer;
        &:hover {
          color: #1976ff;
        }
      }
    }
  }
}
</style>
